import {
  GTMSpotlightCarouselData,
  GTMSpotlightCarouselVariant,
  GTMSpotlightCarouselTestResult,
  UseGTMSpotlightCarousel,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "gtmSpotlightCarousel";

const useGTMSpotlightCarousel: UseGTMSpotlightCarousel = () => {
  const { isLoading, value } = useMonarchRule<{
    data: GTMSpotlightCarouselData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading,
      variant: "control",
    } as GTMSpotlightCarouselTestResult;
  }
  const { data } = value;

  // Determine variant based on sections data
  let variant: GTMSpotlightCarouselVariant;
  if (data?.visible) {
    variant = "test";
  } else {
    variant = "control";
  }
  return {
    isLoading: false,
    variant,
    data,
  };
};

export default useGTMSpotlightCarousel;
